import { render, staticRenderFns } from "./scene2Pc.vue?vue&type=template&id=06682eb8&scoped=true&"
import script from "./scene2Pc.vue?vue&type=script&lang=js&"
export * from "./scene2Pc.vue?vue&type=script&lang=js&"
import style0 from "./scene2Pc.vue?vue&type=style&index=0&id=06682eb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06682eb8",
  null
  
)

export default component.exports